(function () {
  'use strict';
  if (window.__strongCompareLoaded) return;
  window.__strongCompareLoaded = true;

  function loadOfficialCatalog(config, dataNode) {
    if (!config || typeof config.dataUrl !== 'string' || !config.dataUrl) return Promise.resolve(null);
    if (!window.__spcCatalogPromise) {
      window.__spcCatalogPromise = fetch(config.dataUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Catálogo oficial indisponível');
          return response.json();
        })
        .then(function (catalog) {
          if (!catalog || typeof catalog !== 'object') throw new Error('Catálogo oficial inválido');
          catalog.draft = config.draft === true;
          catalog.currency = catalog.currency || config.currency || 'EUR';
          catalog.dataUrl = config.dataUrl;
          dataNode.textContent = JSON.stringify(catalog);
          document.dispatchEvent(new CustomEvent('spc:data-ready'));
          return catalog;
        });
    }
    return window.__spcCatalogPromise;
  }

  function init() {
    var dataNode = document.getElementById('spc-data');
    if (!dataNode) return;
    var config;
    try { config = JSON.parse(dataNode.textContent); } catch (_) { return; }
    if (!Array.isArray(config.products)) {
      if (!config.dataUrl) return;
      loadOfficialCatalog(config, dataNode).then(function () { init(); }).catch(function () { /* Fail closed: no comparator without data. */ });
      return;
    }
    if (window.__strongCompareInitialized || document.querySelector('[data-spc-ui].spc-bar')) return;
    window.__strongCompareInitialized = true;
    var products = (Array.isArray(config.products) ? config.products : []).filter(function (p) {
      return p && p.id && p.handle && p.title;
    });
    if (!products.length) { window.__strongCompareInitialized = false; return; }
    // The catalogue asset is not public-ready until every required technical
    // field has a concrete owner-confirmed value. Keep the whole interface
    // off while the data request is being collected.
    if (config.audit && config.audit.publicCatalogComplete !== true) {
      window.__strongCompareBlocked = true;
      window.__strongCompareInitialized = false;
      return;
    }
    var byId = new Map(products.map(function (p) { return [String(p.id), p]; }));
    var byHandle = new Map(products.map(function (p) { return [p.handle, p]; }));
    var key = 'strong-padel-comparison-v1';
    var selected = [];
    try {
      var saved = JSON.parse(sessionStorage.getItem(key) || '[]');
      if (Array.isArray(saved)) selected = Array.from(new Set(saved.map(String))).filter(function (id) { return byId.has(id); }).slice(0, 3);
    } catch (_) { /* Storage is optional. */ }
    var onlyDifferences = false;
    var mobilePair = [];
    var mq = window.matchMedia('(max-width: 749px)');
    var returnFocus = null;
    var pendingInjection = 0;
    var commercialTargets = new Map();
    var commercialState = new Map();
    var commercialQueue = [];
    var queuedCommercial = new Set();
    var desiredCommercial = new Set();
    var commercialActive = 0;
    var pendingCommercial = 0;
    var choices = new Map();
    var qualitativeFields = ['feel', 'style', 'level', 'summary'];
    var rows = [
      ['weight', 'Peso'], ['shape', 'Formato'], ['balance', 'Balanço'],
      ['feel', 'Toque'], ['style', 'Estilo de jogo'], ['level', 'Nível recomendado'],
      ['face', 'Faces'], ['core', 'Núcleo'], ['surface', 'Superfície'], ['summary', 'Indicada para quem procura…']
    ];
    var formatMoney;
    try { formatMoney = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: config.currency || 'EUR' }); }
    catch (_) { formatMoney = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }); }
    // Strict data gate: do not mount a partial comparison. The owner supplies
    // missing values first; until then no public table or pending placeholder
    // is rendered for the catalog.
    if (!products.every(comparisonReady)) {
      window.__strongCompareBlocked = true;
      window.__strongCompareInitialized = false;
      return;
    }

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    function owned(node) { node.setAttribute('data-spc-ui', ''); return node; }
    function action(label, type, id, cls) {
      var button = el('button', cls || 'spc-button', label);
      button.type = 'button';
      button.dataset.spcAction = type;
      if (id) button.dataset.spcId = String(id);
      return button;
    }
    function safeUrl(value, external) {
      if (typeof value !== 'string' || !value.trim()) return null;
      try {
        var url = new URL(value, location.origin);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
        if (!external && url.origin !== location.origin) return null;
        return external ? url.href : url.pathname + url.search + url.hash;
      } catch (_) { return null; }
    }
    function productUrl(p) { return safeUrl(p.url, false) || '/products/' + encodeURIComponent(p.handle); }
    function imageFor(p, cls) {
      var img = el('img', cls || 'spc-image');
      var src = safeUrl(p.image, true);
      if (src) img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 120;
      img.height = 120;
      img.addEventListener('error', function () { img.hidden = true; }, { once: true });
      return img;
    }
    function normalizeBalance(value) {
      var normalized = searchText(value);
      if (!normalized) return null;
      // Only the three owner-approved labels are valid.  Composite/legacy
      // wording must be resolved in the data build before the UI mounts.
      if (normalized === 'baixo') return 'Baixo';
      if (normalized === 'medio') return 'Médio';
      if (normalized === 'alto') return 'Alto';
      return null;
    }
    function spec(p, field) {
      var value = p.specs && p.specs[field];
      if (value && typeof value === 'object') value = value.value;
      if (field === 'balance') return normalizeBalance(value);
      return value === null || value === undefined || String(value).trim() === '' ? null : String(value);
    }
    function comparisonReady(product) {
      return rows.every(function (row) { return spec(product, row[0]) !== null; });
    }
    function searchText(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-PT').trim();
    }
    function isQualitative(p, field) {
      return qualitativeFields.indexOf(field) !== -1 || (Array.isArray(p.qualitativeFields) && p.qualitativeFields.indexOf(field) !== -1) || Boolean(p.specs && p.specs[field] && p.specs[field].qualitative);
    }
    function priceText(p) {
      return typeof p.price === 'number' && Number.isFinite(p.price) && p.price >= 0 ? formatMoney.format(p.price / 100) : '';
    }
    function stockText(p) { return p.available === true ? 'Disponível' : p.available === false ? 'Esgotada' : ''; }
    function save() {
      try { sessionStorage.setItem(key, JSON.stringify(selected)); } catch (_) { /* No dependency on storage permissions. */ }
    }
    function announce(message) { status.textContent = message; }

    var dialog = owned(el('dialog', 'spc-dialog'));
    dialog.id = 'spc-dialog';
    dialog.setAttribute('aria-labelledby', 'spc-title');
    dialog.setAttribute('aria-describedby', 'spc-intro');
    var shell = el('div', 'spc-shell');
    var heading = el('header', 'spc-header');
    var headingText = el('div', 'spc-heading');
    headingText.appendChild(el('p', 'spc-eyebrow', config.draft ? 'STRONG PADEL · VERSÃO DE TESTE' : 'STRONG PADEL · COMPARADOR'));
    var title = el('h2', 'spc-title', 'Escolhe a tua próxima raquete');
    title.id = 'spc-title';
    headingText.appendChild(title);
    var intro = el('p', 'spc-intro', 'Escolhe duas ou três raquetes e vê as diferenças lado a lado.');
    intro.id = 'spc-intro';
    headingText.appendChild(intro);
    heading.appendChild(headingText);
    var close = action('Fechar ×', 'close', null, 'spc-close');
    close.setAttribute('aria-label', 'Fechar comparador');
    heading.appendChild(close);
    shell.appendChild(heading);
    var catalogueHeading = el('div', 'spc-catalogue-heading');
    catalogueHeading.appendChild(el('h3', '', 'Encontra uma raquete'));
    var catalogueToggle = action('Ocultar lista', 'catalogue', null, 'spc-text-button');
    catalogueToggle.setAttribute('aria-expanded', 'true');
    catalogueToggle.setAttribute('aria-controls', 'spc-catalogue-panel');
    catalogueHeading.appendChild(catalogueToggle);
    shell.appendChild(catalogueHeading);
    var cataloguePanel = el('section', 'spc-catalogue-panel');
    cataloguePanel.id = 'spc-catalogue-panel';
    cataloguePanel.setAttribute('aria-label', 'Escolher raquetes');
    var filters = el('div', 'spc-filters');
    var searchLabel = el('label', 'spc-filter-label', 'Pesquisar por nome ou marca');
    var searchInput = el('input', 'spc-search');
    searchInput.type = 'search';
    searchInput.id = 'spc-search';
    searchInput.placeholder = 'Ex.: Head, AT10, Viper…';
    searchInput.autocomplete = 'off';
    searchInput.setAttribute('aria-controls', 'spc-catalogue');
    searchLabel.appendChild(searchInput);
    filters.appendChild(searchLabel);
    var brandLabel = el('label', 'spc-filter-label', 'Marca');
    var brandSelect = el('select', 'spc-brand-select');
    brandSelect.id = 'spc-brand';
    brandSelect.setAttribute('aria-controls', 'spc-catalogue');
    var allBrands = el('option', '', 'Todas as marcas');
    allBrands.value = '';
    brandSelect.appendChild(allBrands);
    Array.from(new Set(products.map(function (p) { return p.brand; }).filter(Boolean))).sort(function (a, b) { return a.localeCompare(b, 'pt-PT'); }).forEach(function (brand) {
      var option = el('option', '', brand);
      option.value = brand;
      brandSelect.appendChild(option);
    });
    brandLabel.appendChild(brandSelect);
    filters.appendChild(brandLabel);
    cataloguePanel.appendChild(filters);
    var resultCount = el('p', 'spc-result-count');
    resultCount.id = 'spc-result-count';
    resultCount.setAttribute('role', 'status');
    resultCount.setAttribute('aria-live', 'polite');
    resultCount.setAttribute('aria-atomic', 'true');
    cataloguePanel.appendChild(resultCount);
    var catalogue = el('div', 'spc-catalogue');
    catalogue.id = 'spc-catalogue';
    catalogue.setAttribute('aria-label', 'Raquetes disponíveis para comparar');
    products.forEach(function (p) {
      var choice = action('', 'toggle', p.id, 'spc-choice');
      choice.appendChild(imageFor(p, 'spc-choice-image'));
      choice.appendChild(el('span', 'spc-choice-name', p.title));
      choice.appendChild(el('span', 'spc-choice-state', 'Selecionar'));
      choice.setAttribute('aria-pressed', 'false');
      catalogue.appendChild(choice);
      choices.set(String(p.id), choice);
      commercialTargets.set(choice, String(p.id));
    });
    cataloguePanel.appendChild(catalogue);
    var noResults = el('div', 'spc-no-results');
    noResults.appendChild(el('p', '', 'Nenhuma raquete corresponde à pesquisa. A tua seleção mantém-se.'));
    noResults.appendChild(action('Limpar filtros', 'reset-filters', null, 'spc-text-button'));
    noResults.hidden = true;
    cataloguePanel.appendChild(noResults);
    shell.appendChild(cataloguePanel);
    var toolbar = el('div', 'spc-toolbar');
    var differenceLabel = el('label', 'spc-differences');
    var differenceInput = el('input');
    differenceInput.type = 'checkbox';
    differenceInput.id = 'spc-differences';
    differenceInput.dataset.spcChange = 'differences';
    differenceLabel.appendChild(differenceInput);
    differenceLabel.appendChild(el('span', '', 'Só diferenças'));
    toolbar.appendChild(differenceLabel);
    toolbar.appendChild(action('Limpar seleção', 'clear', null, 'spc-text-button'));
    shell.appendChild(toolbar);
    var status = el('p', 'spc-status');
    status.id = 'spc-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    shell.appendChild(status);
    var commercialStatus = el('div', 'spc-commercial-status');
    var commercialMessage = el('span');
    commercialMessage.setAttribute('role', 'status');
    commercialMessage.setAttribute('aria-live', 'polite');
    commercialStatus.appendChild(commercialMessage);
    var retryCommercial = action('Tentar novamente', 'refresh', null, 'spc-text-button');
    retryCommercial.hidden = true;
    commercialStatus.appendChild(retryCommercial);
    commercialStatus.hidden = true;
    shell.appendChild(commercialStatus);
    var mobile = el('div', 'spc-mobile-pair');
    shell.appendChild(mobile);
    var comparison = el('div', 'spc-comparison');
    shell.appendChild(comparison);
    var notes = el('footer', 'spc-notes');
    shell.appendChild(notes);
    dialog.appendChild(shell);
    document.body.appendChild(dialog);

    var bar = owned(el('aside', 'spc-bar'));
    bar.setAttribute('aria-label', 'Seleção para comparação');
    var barCount = el('span', 'spc-bar-count');
    bar.appendChild(barCount);
    bar.appendChild(action('Comparar', 'open', null, 'spc-button spc-button-primary'));
    bar.appendChild(action('Limpar', 'clear', null, 'spc-text-button'));
    document.body.appendChild(bar);

    function open(trigger) {
      returnFocus = trigger || document.activeElement;
      render();
      if (!dialog.open) dialog.showModal();
      updateButtons();
      close.focus();
      refreshCommercial();
    }

    function filterCatalogue() {
      var terms = searchText(searchInput.value).split(/\s+/).filter(Boolean);
      var count = 0;
      products.forEach(function (p) {
        var text = searchText(p.title + ' ' + (p.brand || ''));
        var matches = (!brandSelect.value || p.brand === brandSelect.value) && terms.every(function (term) { return text.indexOf(term) !== -1; });
        choices.get(String(p.id)).hidden = !matches;
        if (matches) count += 1;
      });
      catalogue.scrollTop = 0;
      catalogue.scrollLeft = 0;
      resultCount.textContent = count + (count === 1 ? ' raquete encontrada' : ' raquetes encontradas') + ' · ' + products.length + ' no comparador';
      noResults.hidden = count !== 0;
      catalogue.hidden = count === 0;
      requestCommercialRefresh();
    }
    function targetVisible(node) {
      if (!node.isConnected || node.closest('[hidden]')) return false;
      var inDialog = dialog.contains(node);
      if (inDialog !== dialog.open) return false;
      var rect = node.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return false;
      if (inDialog) {
        var listRect = catalogue.getBoundingClientRect();
        var shellRect = shell.getBoundingClientRect();
        var headerRect = heading.getBoundingClientRect();
        return rect.bottom > Math.max(listRect.top, shellRect.top, headerRect.bottom) && rect.top < Math.min(listRect.bottom, shellRect.bottom) && rect.right > listRect.left && rect.left < listRect.right;
      }
      return true;
    }
    function requestCommercialRefresh() {
      if (!pendingCommercial) pendingCommercial = window.setTimeout(function () { pendingCommercial = 0; refreshCommercial(); }, 120);
    }
    function refreshCommercial(force) {
      desiredCommercial = new Set(selected);
      commercialTargets.forEach(function (id, node) {
        if (!node.isConnected) commercialTargets.delete(node);
        else if (targetVisible(node)) desiredCommercial.add(id);
      });
      // Rebuild the waiting queue from current visibility; selection has priority.
      commercialQueue = [];
      queuedCommercial.clear();
      desiredCommercial.forEach(function (id) {
        var state = commercialState.get(id);
        if (state && (state.pending || (!force && Date.now() < state.nextAt))) return;
        commercialQueue.push(id);
        queuedCommercial.add(id);
      });
      pumpCommercial();
      updateCommercialUI();
    }
    function pumpCommercial() {
      while (commercialActive < 3 && commercialQueue.length) {
        var id = commercialQueue.shift();
        queuedCommercial.delete(id);
        if (!desiredCommercial.has(id)) continue;
        var state = commercialState.get(id);
        if (state && state.pending) continue;
        commercialState.set(id, { pending: true, nextAt: 0 });
        commercialActive += 1;
        fetchCommercial(id);
      }
    }
    async function fetchCommercial(id) {
      var p = byId.get(id);
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 6000);
      var failed = false;
      try {
        var endpoint = new URL(productUrl(p), location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
        endpoint.search = '';
        endpoint.hash = '';
        var response = await fetch(endpoint.href, { method: 'GET', credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product request failed');
        var latest = await response.json();
        if (String(latest.id) !== String(p.id) || !Array.isArray(latest.variants) || typeof latest.available !== 'boolean') throw new Error('Unexpected product');
        var variant = latest.variants.find(function (item) { return item.available === true; }) || latest.variants[0];
        if (!variant || typeof variant.price !== 'number' || !Number.isFinite(variant.price) || variant.price < 0) throw new Error('Missing price');
        p.price = variant.price;
        p.available = latest.available;
        p.commercialNote = null;
      } catch (_) {
        failed = true;
        p.price = null;
        p.available = null;
        p.commercialNote = 'Não foi possível atualizar o preço e a disponibilidade. Confirma estes dados na ficha da raquete.';
      } finally {
        window.clearTimeout(timeout);
        commercialState.set(id, { pending: false, failed: failed, nextAt: Date.now() + (failed ? 15000 : 60000) });
        commercialActive -= 1;
        pumpCommercial();
        updateCommercialUI();
      }
    }
    function updateCommercialUI() {
      // Update text in place: price requests must never rebuild focused controls.
      comparison.querySelectorAll('[data-spc-commercial-id]').forEach(function (cell) {
        var p = byId.get(cell.dataset.spcCommercialId);
        cell.querySelector('.spc-price').textContent = priceText(p);
        cell.querySelector('.spc-stock').textContent = stockText(p);
      });
      notes.querySelectorAll('[data-spc-commercial-note]').forEach(function (node) {
        var p = byId.get(node.dataset.spcCommercialNote);
        node.textContent = p.commercialNote || '';
        node.hidden = !p.commercialNote;
      });
      var visible = selectedVisible();
      var busy = visible.some(function (id) { var state = commercialState.get(id); return (state && state.pending) || queuedCommercial.has(id); });
      var failed = visible.some(function (id) { return Boolean(byId.get(id).commercialNote); });
      commercialStatus.hidden = !dialog.open || !visible.length || (!busy && !failed);
      commercialMessage.textContent = busy ? 'A atualizar preços e disponibilidade…' : failed ? 'Não foi possível atualizar os dados comerciais. Consulta a ficha da raquete ou tenta novamente.' : '';
      retryCommercial.hidden = busy || !failed;
    }
    function updateButtons() {
      document.querySelectorAll('[data-spc-action="toggle"]').forEach(function (button) {
        var product = byId.get(button.dataset.spcId);
        if (!product) return;
        var active = selected.indexOf(button.dataset.spcId) !== -1;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('spc-selected', active);
        var state = button.querySelector('.spc-choice-state');
        if (state) state.textContent = active ? 'Selecionada ✓' : 'Selecionar';
        else button.textContent = button.classList.contains('spc-remove') ? 'Retirar' : active ? 'Selecionada ✓' : 'Comparar';
        button.setAttribute('aria-label', (active ? 'Retirar ' : 'Comparar ') + product.title);
      });
      bar.hidden = selected.length === 0 || dialog.open;
      barCount.textContent = selected.length + ' de 3 raquetes';
      document.body.classList.toggle('spc-has-selection', selected.length > 0);
      differenceInput.disabled = selected.length < 2;
      document.querySelectorAll('[data-spc-action="clear"]').forEach(function (button) { button.disabled = selected.length === 0; });
    }
    function selectedVisible() {
      if (!mq.matches || selected.length <= 2) return selected.slice();
      mobilePair = mobilePair.filter(function (id, index, list) { return selected.indexOf(id) !== -1 && list.indexOf(id) === index; });
      selected.forEach(function (id) { if (mobilePair.length < 2 && mobilePair.indexOf(id) === -1) mobilePair.push(id); });
      return mobilePair.slice();
    }
    function renderMobilePair(visible) {
      mobile.replaceChildren();
      mobile.hidden = !mq.matches || selected.length < 3;
      if (mobile.hidden) return;
      mobile.appendChild(el('p', 'spc-pair-help', 'Tens três selecionadas. Escolhe as duas que queres ver agora.'));
      visible.forEach(function (id, index) {
        var label = el('label', 'spc-pair-label', 'Raquete ' + (index + 1));
        var select = el('select', 'spc-pair-select');
        select.dataset.spcChange = 'pair';
        select.dataset.spcSlot = String(index);
        selected.forEach(function (selectedId) {
          var option = el('option', '', byId.get(selectedId).title);
          option.value = selectedId;
          option.selected = selectedId === id;
          select.appendChild(option);
        });
        label.appendChild(select);
        mobile.appendChild(label);
      });
    }
    function renderNotes(visible) {
      notes.replaceChildren();
      // Source provenance remains in the catalogue, not in the comparator footer.
      visible.forEach(function (id) {
        var p = byId.get(id);
        var commercialNote = el('p', 'spc-commercial-note', p.commercialNote || '');
        commercialNote.dataset.spcCommercialNote = id;
        commercialNote.hidden = !p.commercialNote;
        notes.appendChild(commercialNote);
      });
    }
    function renderTable(visible) {
      comparison.replaceChildren();
      if (selected.length < 2) {
        comparison.appendChild(el('div', 'spc-empty', selected.length === 0 ? 'Começa por escolher duas raquetes acima.' : 'Escolhe mais uma raquete para veres a comparação.'));
        return;
      }
      if (!visible.every(function (id) { return comparisonReady(byId.get(id)); })) return;
      var scroll = el('div', 'spc-table-scroll');
      var table = el('table', 'spc-table');
      table.dataset.spcColumns = String(visible.length);
      var caption = el('caption', 'spc-sr-only', 'Comparação de características de ' + visible.map(function (id) { return byId.get(id).title; }).join(' e '));
      table.appendChild(caption);
      var thead = el('thead');
      var headerRow = el('tr');
      var corner = el('th', 'spc-feature-heading', 'Características');
      corner.scope = 'col';
      headerRow.appendChild(corner);
      visible.forEach(function (id) {
        var p = byId.get(id);
        var cell = el('th', 'spc-product-heading');
        cell.scope = 'col';
        cell.dataset.spcCommercialId = id;
        if (p.badge) cell.appendChild(el('span', 'spc-product-badge', String(p.badge)));
        cell.appendChild(imageFor(p));
        cell.appendChild(el('span', 'spc-product-name', p.title));
        cell.appendChild(el('span', 'spc-price', priceText(p)));
        cell.appendChild(el('span', 'spc-stock', stockText(p)));
        var link = el('a', 'spc-product-link', 'Ver raquete');
        link.href = productUrl(p);
        cell.appendChild(link);
        cell.appendChild(action('Retirar', 'toggle', id, 'spc-remove'));
        headerRow.appendChild(cell);
      });
      thead.appendChild(headerRow);
      table.appendChild(thead);
      var tbody = el('tbody');
      var shown = 0;
      rows.forEach(function (row) {
        var values = visible.map(function (id) { return spec(byId.get(id), row[0]); });
        var allKnown = values.every(function (value) { return value !== null; });
        var identical = allKnown && values.every(function (value) { return value.trim().toLocaleLowerCase('pt-PT') === values[0].trim().toLocaleLowerCase('pt-PT'); });
        if (onlyDifferences && identical) return;
        shown += 1;
        var tr = el('tr', identical ? 'spc-row-same' : 'spc-row-different');
        var label = el('th', 'spc-row-label', row[1]);
        label.scope = 'row';
        if (visible.some(function (id) { return isQualitative(byId.get(id), row[0]); })) label.appendChild(el('span', 'spc-qualifier', 'Orientação qualitativa'));
        tr.appendChild(label);
        values.forEach(function (value, index) {
          var td = el('td', '', value === null ? '' : value);
          var detail = byId.get(visible[index]).specs && byId.get(visible[index]).specs[row[0]];
          if (detail && typeof detail === 'object' && detail.note) td.appendChild(el('span', 'spc-note', String(detail.note)));
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      if (!shown) {
        var emptyRow = el('tr');
        var emptyCell = el('td', 'spc-empty', 'Não há características definidas para esta seleção.');
        emptyCell.colSpan = visible.length + 1;
        emptyRow.appendChild(emptyCell);
        tbody.appendChild(emptyRow);
      }
      table.appendChild(tbody);
      scroll.appendChild(table);
      comparison.appendChild(scroll);
    }
    function render() {
      var visible = selectedVisible();
      renderMobilePair(visible);
      renderTable(visible);
      renderNotes(visible);
      updateButtons();
      updateCommercialUI();
    }
    function toggle(id) {
      if (!byId.has(id)) return;
      var at = selected.indexOf(id);
      if (at !== -1) selected.splice(at, 1);
      else if (selected.length >= 3) {
        if (!dialog.open) open(document.activeElement);
        announce('Já tens três raquetes. Retira uma para acrescentar outro modelo.');
        return;
      } else selected.push(id);
      save();
      render();
      announce(selected.length + ' de 3 raquetes selecionadas.');
      requestCommercialRefresh();
    }
    function handleFrom(url) {
      try {
        var parts = new URL(url, location.origin).pathname.split('/');
        var index = parts.indexOf('products');
        return index !== -1 ? decodeURIComponent(parts[index + 1] || '') : '';
      } catch (_) { return ''; }
    }
    function banner() {
      if (document.querySelector('.spc-banner')) return;
      var grid = document.querySelector('#product-grid');
      var collection = document.querySelector('.collection');
      var current = byHandle.get(handleFrom(location.href));
      var form = current && document.querySelector('product-form, form[action*="/cart/add"]');
      if (!grid && !collection && !form) return;
      var block = owned(el('div', 'spc-banner'));
      var copy = el('div', 'spc-banner-copy');
      copy.appendChild(el('strong', '', 'Qual é a tua próxima raquete?'));
      copy.appendChild(el('span', '', 'Compara ' + products.length + ' modelos, característica a característica.'));
      block.appendChild(copy);
      block.appendChild(action('Abrir comparador', 'open', null, 'spc-button spc-button-primary'));
      if (grid) grid.parentNode.insertBefore(block, grid);
      else if (collection) collection.prepend(block);
      else form.parentNode.insertBefore(block, form);
    }
    function inject() {
      pendingInjection = 0;
      document.querySelectorAll('.card-wrapper').forEach(function (card) {
        if (card.querySelector('.spc-card-button')) return;
        var links = card.querySelectorAll('a[href*="/products/"]');
        var product = null;
        for (var i = 0; i < links.length && !product; i++) product = byHandle.get(handleFrom(links[i].href));
        if (!product) return;
        var button = owned(action('Comparar', 'toggle', product.id, 'spc-card-button'));
        button.setAttribute('aria-pressed', 'false');
        card.appendChild(button);
        commercialTargets.set(button, String(product.id));
      });
      var current = byHandle.get(handleFrom(location.href));
      if (current && !document.querySelector('.spc-product-button')) {
        var form = document.querySelector('product-form, form[action*="/cart/add"]');
        if (form) form.parentNode.insertBefore(owned(action('Comparar', 'toggle', current.id, 'spc-product-button spc-button')), form.nextSibling);
      }
      banner();
      updateButtons();
      requestCommercialRefresh();
    }
    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-spc-action]');
      if (!target) return;
      event.preventDefault();
      var type = target.dataset.spcAction;
      if (type === 'open') open(target);
      else if (type === 'close') dialog.close();
      else if (type === 'catalogue') {
        cataloguePanel.hidden = !cataloguePanel.hidden;
        catalogueToggle.setAttribute('aria-expanded', String(!cataloguePanel.hidden));
        catalogueToggle.textContent = cataloguePanel.hidden ? 'Mostrar lista' : 'Ocultar lista';
        requestCommercialRefresh();
      } else if (type === 'reset-filters') {
        searchInput.value = '';
        brandSelect.value = '';
        filterCatalogue();
        searchInput.focus();
      } else if (type === 'refresh') refreshCommercial(true);
      else if (type === 'toggle') {
        var wasRemove = target.classList.contains('spc-remove');
        var toggledId = target.dataset.spcId;
        toggle(toggledId);
        if (wasRemove) {
          var choice = catalogue.querySelector('[data-spc-id="' + toggledId + '"]');
          if (choice && !choice.hidden && !cataloguePanel.hidden) choice.focus();
          else close.focus();
        }
      }
      else if (type === 'clear') {
        selected = [];
        mobilePair = [];
        save();
        render();
        announce('Seleção limpa. Escolhe duas raquetes para comparar.');
        requestCommercialRefresh();
      }
    });
    searchInput.addEventListener('input', filterCatalogue);
    brandSelect.addEventListener('change', filterCatalogue);
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target.dataset.spcChange === 'differences') {
        onlyDifferences = target.checked;
        renderTable(selectedVisible());
      } else if (target.dataset.spcChange === 'pair') {
        var slot = Number(target.dataset.spcSlot);
        var other = slot === 0 ? 1 : 0;
        var previous = mobilePair[slot];
        if (mobilePair[other] === target.value) mobilePair[other] = previous;
        mobilePair[slot] = target.value;
        render();
        var replacement = mobile.querySelector('[data-spc-slot="' + slot + '"]');
        if (replacement) replacement.focus();
      }
    });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      updateButtons();
      requestCommercialRefresh();
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
    function onViewport() { render(); requestCommercialRefresh(); }
    if (mq.addEventListener) mq.addEventListener('change', onViewport);
    else mq.addListener(onViewport);
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && !node.closest('[data-spc-ui]') && (node.matches('.card-wrapper, #product-grid, product-form') || node.querySelector('.card-wrapper, #product-grid, product-form'));
        });
      });
      if (relevant && !pendingInjection) pendingInjection = window.setTimeout(inject, 100);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('hashchange', function () { if (location.hash === '#comparar') open(); });
    document.addEventListener('scroll', requestCommercialRefresh, { passive: true, capture: true });
    window.addEventListener('resize', requestCommercialRefresh, { passive: true });
    filterCatalogue();
    render();
    inject();
    if (location.hash === '#comparar' || document.getElementById('spc-standalone')) open();
  }
  document.addEventListener('spc:data-ready', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
